import { defineComponent as _defineComponent } from 'vue'
import RewardsSideMenuContents from './components/RewardsSideMenuContents.vue';
import SideMenu from 'Src/js/components/SideMenu.vue';
import SideMenuHeaderButton from '../SideMenuHeaderButton.vue';
import Spinner from 'JS/components/Spinner.vue';
import { checkWebpFeature } from 'JS/global/images';
import { computed, ref } from 'vue';
import { onMounted, PropType, watch } from 'vue';
import { IJoinRewardsStep } from 'JS/types/rewards';
import { provideServices } from '../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardsSignupSidePanel',
  props: {
	show: {
		type: Boolean
	},
	step: {
		type: String as PropType<IJoinRewardsStep>,
		default: "join",
		required: false
	},
	reloadOnClose: {
		type: Boolean,
		default: false,
		required: false,
	},
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
	(e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

provideServices();





const forceReload = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const joinRewardsStep = ref<IJoinRewardsStep>(null);
const backArrowRouter = ref<Array<IJoinRewardsStep>>([]);

const showBackArrow = computed((): boolean => {
	return backArrowRouter.value.length != 0;
});

function updateSideMenuHeaderButton(prevPage: IJoinRewardsStep | "clear") {
	if (prevPage === "clear") {
		backArrowRouter.value = [];
	} else {
		backArrowRouter.value.push(prevPage);
	}
}

function handleBackArrow() {
	joinRewardsStep.value = backArrowRouter.value.pop();
}

function determineClose() {
	if (forceReload.value || props.reloadOnClose) window.location.reload();
	emit('close');
}

function handleIsLoading(value: boolean) {
	isLoading.value = value;
}

function reset() {
	backArrowRouter.value = [];
	joinRewardsStep.value = props.step;
}

watch(() => props.step, (newPage) =>  {
	joinRewardsStep.value = newPage;
}, { immediate: true });

//Adds this image to the cache so it's pre-loaded before sidepanel opening.
onMounted(() => {
	checkWebpFeature("alpha").then(isSupported => {
		if (isSupported) {
			new Image().src = "/assets/images/rewards/rewards-header-mobile.webp";
		} else {
			new Image().src = "/assets/images/rewards/rewards-header-mobile.png";
		}
	});
});


return { __sfc: true,props, emit, forceReload, isLoading, joinRewardsStep, backArrowRouter, showBackArrow, updateSideMenuHeaderButton, handleBackArrow, determineClose, handleIsLoading, reset, RewardsSideMenuContents, SideMenu, SideMenuHeaderButton, Spinner }
}

})